export const FETCH_PREMIUM_OFFERS_SHOP =
  "premiumOffersShop/FETCH_PREMIUM_OFFERS_SHOP";
export type FETCH_PREMIUM_OFFERS_SHOP = typeof FETCH_PREMIUM_OFFERS_SHOP;

export const SET_PREMIUM_OFFERS_SHOP_RESULTS =
  "premiumOffersShop/SET_PREMIUM_OFFERS_SHOP_RESULTS";
export type SET_PREMIUM_OFFERS_SHOP_RESULTS =
  typeof SET_PREMIUM_OFFERS_SHOP_RESULTS;
